/* Velvet · barra fixa de compra no celular (snippets/velvet-barra-compra.liquid)
   - vai para o <body>: dentro dos blocos do produto há transform (animação de entrada) e
     position: fixed passaria a valer em relação ao bloco, não à tela
   - aparece quando o botão principal saiu da tela por cima (a cliente já passou por ele)
   - copia do botão principal o texto e o disabled, e do preço da página o valor; a variante
     vem das opções marcadas no formulário
   - o botão da barra só clica no botão principal: a sacola do tema faz o resto
   - tocar na variante ("Marsala · PP") sobe a página até o seletor de cor e tamanho */
(function () {
  var barra = document.querySelector('[data-velvet-barra-compra]');
  var principal = document.querySelector('[id^="AddToCart--"][id$="__main"]') || document.querySelector('.product__submit__add');
  if (!barra || !principal || !('IntersectionObserver' in window)) return;

  document.body.appendChild(barra);
  barra.hidden = false;

  var botao = barra.querySelector('[data-barra-botao]');
  var preco = barra.querySelector('[data-barra-preco]');
  var variante = barra.querySelector('[data-barra-variante]');
  var varianteTexto = barra.querySelector('[data-barra-variante-texto]');
  var form = principal.closest('form');
  var section = principal.closest('[data-section-id]') || document;
  var precoDaPagina = section.querySelector('.product__price [data-product-price]');

  function sincronizar() {
    var texto = principal.querySelector('[data-add-to-cart-text]') || principal;
    botao.textContent = texto.textContent.trim();
    botao.disabled = principal.disabled;
    if (precoDaPagina) preco.textContent = precoDaPagina.textContent.trim();
    var escolhas = form ? Array.prototype.map.call(form.querySelectorAll('input[type="radio"]:checked'), function (i) { return i.value; }) : [];
    varianteTexto.textContent = escolhas.join(' · ');
    variante.hidden = escolhas.length === 0;
  }

  var observar = { attributes: true, childList: true, subtree: true, characterData: true };
  new MutationObserver(sincronizar).observe(principal, observar);
  if (precoDaPagina) new MutationObserver(sincronizar).observe(precoDaPagina, observar);
  if (form) form.addEventListener('change', function () { setTimeout(sincronizar, 60); });
  sincronizar();

  function mostrar(sim) {
    barra.classList.toggle('velvet-barra-compra--visivel', sim);
    barra.setAttribute('aria-hidden', sim ? 'false' : 'true');
    botao.tabIndex = sim ? 0 : -1;
    variante.tabIndex = sim ? 0 : -1;
    document.body.classList.toggle('velvet-barra-visivel', sim);
  }

  new IntersectionObserver(function (entradas) {
    var e = entradas[0];
    mostrar(!e.isIntersecting && e.boundingClientRect.top < 0);
  }).observe(principal);

  variante.addEventListener('click', function () {
    var seletor = (form && form.querySelector('.product__selectors')) || form;
    if (!seletor) return;
    var header = document.querySelector('.site-header');
    var topo = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    var y = seletor.getBoundingClientRect().top + window.scrollY - topo - 16;
    var suave = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: y, behavior: suave ? 'smooth' : 'auto' });
    var marcado = seletor.querySelector('input:checked');
    if (marcado) marcado.focus({ preventScroll: true });
  });

  botao.addEventListener('click', function () {
    if (!principal.disabled) principal.click();
  });
})();
